<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
// import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Vue from "vue";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
// import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import { helpers } from "../../../../helpers/helpers-validate";
import MaskedInput from "vue-text-mask";
// import Switches from "vue-switches";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
// import vSelect from "vue-select";
// Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.
let nit = (value) => helpers.nitIsValid(value);
let correo = (value) => helpers.correo(value);
/**
 * new orden component
 */
export default {
  page: {
    title: "Nueva venta",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // PageHeader,
    // DatePicker,
    // Switches,
    // Vuetable,
    // VuetablePagination,
    // Loader,
    vSelect,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    "masked-input": MaskedInput,
  },
  data() {
    return {
      // variables metodos
      idCaja: 0,
      userT: this.$store.state.authfack.user,
      bandera: false,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
    
      arrayAuto: [],
      anio : '',
      placa : '',
      switchCliente: false,
      formCliente: {
        nombre: "",
        apellido: "",
        nit: "C/F",
        opciones: ["MASCULINO", "FEMENINO"],
        direccion: "",
        telefono: "",
        telefono_cliente: "",
        correo: "",
        cui: "",
        sexo: "",
        compania: "",
        direc: "",
        state: true,
        id: 0,
      },
      
      activa_cliente: false,

 
      arrayCliente: [],
      arrayDepa: [],
      arrayClientes: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase:
        process.env.VUE_APP_URL +
        "productos/stock/busqueda?departamento=" +
        0 +
        "&estante=" +
        0,
      apiBase2: process.env.VUE_APP_URL + "servicios/select",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formPro: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
        placas : "",
        anio:"",
        autoid :"",
        modelo : "",
        observaciones_mecanico: ""
      },
     
      title: "NUEVO SERVICIO",
      items: [
        {
          text: "Servicios",
          href: "/",
        },
        {
          text: "Nuevo Servicio",
          active: true,
        },
      ],

      searchType2: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      optionsFast: {
        theme: "outline",
        position: "top-right",
        duration: 2000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,

      searchLabel2: { nombre: "Nombre", value: "nombre" },
      filterLabel2: { nombre: "Nombre", value: "nombre" },
      showModalL: false, //Loading
      showModalNP: false, //Nuevo cliente
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      search2: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      to2: 0,
      total: 0,
      total2: 0,
      lastPage: 0,
      lastPage2: 0,
      arrayDetalle: [],
      arrayDetalleServicio: [],
      idDepartamento: 0,
      traslado_masivo: false,
      arrayDet: [],
      idCliente: -1,
      isLoad: false,
      arrayModelo : [],
      
   };
  },
  validations: {
    anio : {required},
    placa : {required},
    formCliente: {
      nombre: { required },
      apellido: { required },
      nit: { nit, required },
      direccion: { required },
      telefono: { required },
      correo: { correo, required },
      cui: { required },
      sexo: { required },
      compania: { required },
      direc: { required },
      //telefono_cliente: {required},
    },
    formPro: {
      fecha_compra: { required },
      tienda: { required },
      cliente: { required },
      total: { required },
      placas : {required},
      anio : {required},
      autoid : {required},
      modelo: {required}
    },
  },
  updated() {
    // this.$refs["inputCliente"].focus();
  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    // this.getClientes();
    // this.gettienda();
    await axios
      .get(this.apiUrl + "clientes/cf", {
            headers: { "x-token": this.userT.token },
          })
      .then(({ data }) => {
        //  console.log('mounted', data);
         this.formPro.cliente = {
          id: data.clientes.id,
          nombre: data.clientes.nombre,
          nit_cliente: data.clientes.nit_cliente,
          persona: data.clientes.persona,
        };
        this.idCliente = data.clientes.id;
      })
      .catch(console.error);
      this.validarCaja();
      this.selectCategoria2(1);
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),

  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    validarCaja() {
      // let me = this;
      axios
          .get(
              process.env.VUE_APP_URL +
              "caja/get_validate?" +
              "&usuario=" +
              this.userT.id + "&tienda=" + this.$store.state.authfack.user.tienda,
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then((response) => {
            this.idCaja = response.data.validate.id
            // console.log(this.idCaja);
          });
    },
    async focus(number) {
      if (number == 1) {
        setTimeout(() => {
          this.$refs["inputProductos"].focus();
        }, 300);
      }
      if (number == 2) {
        setTimeout(() => {
          this.$refs["inputServicios"].focus();
        }, 300);
      }
      if (number == 3) {
        setTimeout(() => {
          this.$refs["inputCredito1"].focus();
        }, 300);
      }
    },
  
 
    swCliente() {
      // console.log(this.formPro.cliente);
      this.formPro.cliente = null;
      document.title = "Nueva venta | Zona Auto";
    },
  
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.formCliente.$reset();
          this.limpiarVariables();
          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
        case "productos": {
          this.arrayProductos = [];
          this.producto = "";
          // this.focus(1);
          break;
        }
        case "servicios": {
          this.arrayServicios = [];
          this.servicio = "";
          break;
        }
        case "porcentaje": {
          this.indexPorcentaje = 0;
          this.precioOriginal = "";
          this.precioDescuento = "";
          break;
        }
        case "credito": {
          if (this.formCredito.asignado == false) {
            this.resetCredito();
          }
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      // this.switchCliente = false;
      this.formCliente.id = 0;
      this.formCliente.telefono = "";
      this.formCliente.nombre = "";
      this.formCliente.nit = "C/F";
      this.formCliente.direccion = "";
    },
    limpiarTodo() {
      this.limpiarVariables();
      // this.resetCredito();
      this.formPro;
      this.formPro = {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: "",
        tienda: "",
        cliente: null,
        total: "",
        total_servicios: "",
        total_productos: "",
        state: true,
        id: 0,
      };
      this.gettienda();
      this.porcentaje = "";
      this.indexPorcentaje = "";
      this.precioOriginal = "";
      this.precioDescuento = "";
      this.arrayProductos = [];
      this.producto = "";
      this.arrayServicios = [];
      this.servicio = "";
      this.arrayDetalle = [];
      this.arrayDetalleServicio = [];
      this.search = "";
      this.search2 = "";
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalNP = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },
    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action) {
      if (action == "new-item") {
        this.limpiarVariables();
      }
    },
    async selectClientes(search, loading) {
      let me = this;
      loading(true);
      let url = this.apiUrl + "clientes/busqueda?search=" + search;
      try {
        const response = await axios.get(url, {
            headers: { "x-token": this.userT.token },
          });
        let respuesta = response.data;
        // a: search;
        me.arrayClientes = respuesta;
        loading(false);
      } catch (err) {
        console.log(err);
      }
    },
    getDatosCliente(val1) {
      // console.log(val1)
      let me = this;
      me.loading = true;
      if (val1 == null || val1 == "") {
        me.formPro.cliente = "";
        me.idCliente = -1;
      } else {
        me.idCliente = val1.id;
      }
    },
    async gettienda() {
      let me = this;
      me.formPro.tiendaid = "";
      me.formPro.tienda = "";

      axios
        .get(process.env.VUE_APP_URL + "tiendas/selectById?id="+this.userT.tienda, {
          headers: { "x-token": this.userT.token },
        })
        .then(function (response) {
          // console.log(response);
          me.formPro.tienda = response.data.data.nombre_tienda;
          me.formPro.tiendaid = response.data.data.id;
         
        })
        .catch(function (error) {
          console.log(error);
        })
    },
 
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    //Validaciones antes de guardar
    validaciones(opc) {
      // stop here if form is invalid
      // console.log(this.formPro.cliente);
      this.formPro.tienda = this.userT.tienda;
      const {modelo, placas, anio} = this.formPro;
      this.$v.$touch();
      if (
        this.formPro.cliente == "" ||
        this.formPro.tienda == "" ||
        this.formPro.cliente == null  ||
        placas == "" || anio == "" || modelo == null || modelo == ""

      ) {
        Vue.toasted.error("Ingrese los campos obligatorios", this.options);
      } else {
      
            if (opc == "save") {
            //   console.log("guarda");
              this.save();
            }
          
        }
    
      
    },
    swNit() {
      if (!this.toggleNit) {
        this.formCliente.nit = "C/F";
      }
      // else {
      //   this.formCliente.nit = "";
      // }
    },
    validacionesCliente(opc) {
      // stop here if form is invalid
      this.$v.formCliente.nombre.$touch();
      // this.$v.formCliente.telefono_cliente.$touch();
      // let telC = 0;
      let { nombre } = this.formCliente;

      // for (let i = 0; i < telefono_cliente.length; i++) {
      //   if (telefono_cliente[i] == "_" || telefono_cliente[i] == "") {
      //     telC++;
      //   }
      // }

      if (nombre != "") {
        this.showModalL = true;
        if (opc == "save") {
          // console.log("cliente", this.formCliente);
          this.saveCliente();
        }
        if (opc == "update") {
          this.update();
        }
      } else {
        Vue.toasted.error("Complete los datos del cliente", this.options);
      }
    },
    //Guardar registro
    save() {
      const { modelo, placas, anio, observaciones, cliente, observaciones_mecanico,  } =this.formPro;
        // console.log(cliente);
        axios
          .post(
            process.env.VUE_APP_URL + "ordenes/store",
            {
              caja : this.idCaja,
              usuario: this.userT.id,
              tienda: this.userT.tienda,
              cliente: cliente.id,
              placas,
              anio,
              modelo : modelo.id,
              
              observaciones,
              observaciones_mecanico,
            },
            {
              headers: { "x-token": this.userT.token },
            }
          )
          .then(() => {
            Vue.toasted.success("Nuevo Servicio Guardado", this.optionsFast);
            this.limpiarTodo();
            this.showModalL = false;
          
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          })
          .finally(() => {
            this.showModalL = false;
            this.$router.push({
              name: "taller",
              shallow: true,
            });
          });
    
    },
    saveCliente() {
      const { nombre, nit, direccion, telefono_cliente, correo, cui } =
        this.formCliente;
      const me = this;
      axios
        .post(
          process.env.VUE_APP_URL + "clientes/store",
          {
            nombre,
            nit,
            direccion,
            numero: telefono_cliente,
            email: correo,
            cui,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          // console.log(response.data);
          me.formPro.cliente = response.data.clientes[0];
          this.formPro.cliente = {
          id: response.data.clientes[0].id,
          nombre: response.data.clientes[0].nombre,
          nit_cliente: response.data.clientes[0].nit_cliente,
          persona: response.data.clientes[0].persona,
        };
        this.idCliente = response.data.clientes[0].id;
          this.showModalN = false;
          this.showModalL = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalN = false;
          this.showModalL = false;
        });
    },
    // Funciones para trabajar con detalles
  
  
    async getClientes() {
      this.arrayClientes = [];
      try {
        const response = await axios.get(
          process.env.VUE_APP_URL + "clientes/busqueda",
          {
            headers: { "x-token": this.userT.token },
          }
        );
        this.arrayClientes = response.data;
      } catch (error) {
        console.log(error);
      }
    },
 
   

    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    onFiltered2() {
      this.search2 = this.search2.toLowerCase();
      this.$refs.vuetable2.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onPaginationData2(paginationData) {
      this.to2 = paginationData.to;
      this.total2 = paginationData.total;
      this.lastPage2 = paginationData.last_page;
      // this.items = paginationData.data;
      this.$refs.pagination2.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    changePageSize2() {
      this.$refs.vuetable2.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTypeSearch2(type) {
      this.searchLabel2 = type;
      this.$refs.vuetable2.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    onChangePage2(page) {
      this.$refs.vuetable2.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    makeQueryParams2(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "nombre_persona",
            categoria: this.searchLabel2.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search2,
          };
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    async selectCategoria2(action) {
      if (action == 1) {
        let me = this;
      this.arrayAuto = [];
        try{
            const response = await axios.get(process.env.VUE_APP_URL + "autos/busqueda",{
            headers: { "x-token": this.userT.token}
          });
            me.arrayAuto = response.data.data;
        }catch(error){
            console.log(error)
        }
      }
      if (action == 2) {
        let me = this;
        this.arrayModelo = [];
        try{
            const response = await axios.get(process.env.VUE_APP_URL +"autos/detalles?id=" +this.formPro.autoid.id,{
            headers: { "x-token": this.userT.token}
          })
            me.arrayModelo =response.data.detalles;
            // console.log(me.arrayModelo);
        }catch(error){
            console.log(error)
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <!-- Modal de Nuevo Cliente-->
    <b-modal
      centered
      @show="openModal('save')"
      @hidden="openModal('save')"
      v-model="showModalN"
      id="modalCliente"
      ref="modalCliente"
      title="Nuevo cliente"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
    >
      <form>
        <!-- Nombre -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Nombre</label>
            <input
              id="name"
              v-model="$v.formCliente.nombre.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese un nombre"
              :class="{
                'is-invalid': $v.formCliente.nombre.$error,
              }"
              @input="$v.formCliente.nombre.$touch()"
            />
            <div
              v-if="
                $v.formCliente.nombre.$error && !$v.formCliente.nombre.required
              "
              class="invalid-feedback"
            >
              El nombre es obligatorio.
            </div>
          </div>
        </div>
        <!-- Identificacion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Identificación</label>
            <masked-input
              v-model.trim="formCliente.cui"
              :mask="[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]"
              class="form-control"
              placeholder="Ingrese CUI"
            />
          </div>
        </div>
        <!-- Nit -->
        <div class="col-12">
          <div class="mb-3">
            <label>Nit</label>
            <input
              v-model.trim="$v.formCliente.nit.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese NIT"
            />
            <div class="alert alert-danger" v-if="!$v.formCliente.nit.nit">
              El número de NIT no es valido.
            </div>
          </div>
        </div>
        <!-- Telefono -->
        <div class="col-12">
          <div class="mb-3">
            <label for="name">Teléfono</label>
            <masked-input
              v-model.trim="formCliente.telefono_cliente"
              :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
              class="form-control"
              placeholder="Ingrese el número de teléfono"
            />
          </div>
        </div>
        <!-- Direccion -->
        <div class="col-12">
          <div class="mb-3">
            <label for="phone">Dirección del contacto</label>
            <input
              id="phone"
              v-model.trim="$v.formCliente.direccion.$model"
              type="text"
              class="form-control"
              placeholder="Ingrese Dirección"
            />
          </div>
        </div>
        <!-- Correo -->
        <div class="col-12">
          <div class="mb-3">
            <label for="correo">Correo</label>
            <input
              id="correo"
              v-model.trim="formCliente.correo"
              type="email"
              class="form-control"
              placeholder="Ingrese Correo"
            />
            <div
              class="alert alert-danger"
              v-if="!$v.formCliente.correo.correo"
            >
              El correo es inválido
            </div>
          </div>
        </div>
        <!-- Botones -->
        <div class="text-end pt-5 mt-3">
          <b-button variant="light" @click="showModalN = false"
            >Cerrar
          </b-button>
          <b-button
            @click="validacionesCliente('save')"
            variant="success"
            class="ms-1"
            >Guardar
          </b-button>
        </div>
      </form>
    </b-modal>

 

   
    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- <PageHeader :title="title" :items="items" /> -->
    <!-- ESTA PARTE ES PARA LA CABECERA -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <h4>NUEVA SERVICIO {{ showDate(new Date()) }}</h4>
              </div>
           
              <div class="col" align="right">
           
              </div>
            </div>

            <div class="text-center">
              <div align="left">
              
                <div class="row">
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                     <div >
                        <p class="text-muted mb-2">Cliente</p>
                        <v-select
                          ref="buscadorCliente"
                          v-model.trim="$v.formPro.cliente.$model"
                          :state="!$v.formPro.cliente.$model"
                          @search="selectClientes"
                          label="nombre"
                          :options="arrayClientes"
                          placeholder="Buscar cliente..."
                          @input="getDatosCliente"
                        >
                          <template slot="no-options">
                            <b-button
                              block
                              variant="primary"
                              v-b-modal.modalCliente
                              >Nuevo cliente
                            </b-button>
                          </template>
                          <template v-slot:option="option">
                            {{
                              `${option.persona.nombre_persona} ${option.persona.apellido_persona} ::  ${option.nit_cliente}`
                            }}
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            {{
                              `${option.persona.nombre_persona} ${option.persona.apellido_persona} ::  ${option.nit_cliente}`
                            }}
                          </template>
                        </v-select>
                        <div
                          :class="{
                            'invalid-feedback': true,
                            'd-block':
                              $v.formPro.cliente.$error &&
                              !$v.formPro.cliente.required,
                          }"
                        >
                          Debe seleccionar un cliente
                        </div>
                      </div>
                     
                    </div>
                  </div>
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Marca Automovil</p>
                          <v-select v-model.trim="$v.formPro.autoid.$model" :state="!$v.formPro.autoid.$error"  :options="arrayAuto" label="nombre_auto"
                                @input="selectCategoria2(2)"
                                ></v-select>
                                <div
                                    :class="{
                                        'invalid-feedback': true,
                                        'd-block':
                                            $v.formPro.autoid.$error && !$v.formPro.autoid.required,
                                    }"
                                    >
                                    Debe seleccionar un auto
                            </div>
                        </div>
                    
                    </div>
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Modelo Automovil</p>
                          <v-select  v-model.trim="$v.formPro.modelo.$model" :state="!$v.formPro.modelo.$error"  :options="arrayModelo" label="nombre_modelo"
                    ></v-select>
                    <div
                          :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.modelo.$error && !$v.formPro.modelo.required,
                          }"
                        >
                        Debe seleccionar un modelo
                  </div>
                        </div>
                    
                    </div>
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Placas</p>
                          <input
                            
                            id="name"
                            v-model="$v.formPro.placas.$model"
                            type="text"
                            class="form-control"
                            placeholder="Ingrese las placas"
                            :class="{
                              'is-invalid': $v.formPro.placas.$error,
                            }"
                          />
                        </div>
                        <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.placas.$error &&
                                !$v.formPro.placas.required,
                            }"
                          >
                            Debe ingresar las placas
                          </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Año del vehiculo</p>
                          <input
                            
                            id="name"
                            v-model="$v.formPro.anio.$model"
                            type="number"
                            class="form-control"
                            placeholder="Ingrese el año"
                            :class="{
                              'is-invalid': $v.formPro.anio.$error,
                            }"
                          />
                        </div>
                        <div
                            :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.anio.$error &&
                                !$v.formPro.anio.required,
                            }"
                          >
                            Debe ingresar el año
                          </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Observaciones cliente</p>
                          <textarea
                                name="textarea"
                                v-model="formPro.observaciones"
                                rows="4"
                                cols="40"
                            ></textarea>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="mt-4 mt-sm-0">
                          <p class="text-muted mb-2">Observaciones mecanico</p>
                          <textarea
                                name="textarea"
                                v-model="formPro.observaciones_mecanico"
                                rows="4"
                                cols="40"
                            ></textarea>
                        </div>
                    </div>
                  <div class="col d-grid gap-2">
                        <!-- mas observaciones -->
                  </div>
                  <div class="col d-grid gap-2">
                    
                  </div>
                </div>
                <!-- <br /> -->

                <!-- <h5 v-if="arrayDetalle.length > 0" class="pt-3">
                  &nbsp;&nbsp;&nbsp;Productos
                </h5> -->
              
              </div>

              <!-- Botones -->
              <div class="col-sm-12 pt-3">
                <div class="row">
                  <div class="col">
                    <router-link
                      class="d-grid gap-2"
                      :to="{
                        name: 'taller',
                      }"
                    >
                      <b-button
                        block
                        size="lg"
                        variant="outline-primary"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                        <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b
                          >REGRESAR</b
                        >
                      </b-button>
                    </router-link>
                  </div>
                  <div class="col d-grid gap-2">
                    <b-button
                      block
                      size="lg"
                      variant="outline-success"
                      class="btn btn-rounded mb-2 me-2"
                      @click="validaciones('save')"
                    >
                      <i class="mdi mdi-truck-fast me-1"></i>
                      &nbsp;&nbsp;<b>GUARDAR</b>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </Layout>
</template>
